"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComplexPacking = void 0;
const isComplexPacking = (packing) => {
    const complexPacking = packing;
    return complexPacking.items && complexPacking.items.length >= 2 && complexPacking.option !== undefined;
};
exports.isComplexPacking = isComplexPacking;
